var map = {
	"./404/route.js": "./src/routes/404/route.js",
	"./Booking/route.js": "./src/routes/Booking/route.js",
	"./ConnectorsDetail/route.js": "./src/routes/ConnectorsDetail/route.js",
	"./CreatExecutionAct/route.js": "./src/routes/CreatExecutionAct/route.js",
	"./EdittExecutionAct/route.js": "./src/routes/EdittExecutionAct/route.js",
	"./ExecutActionLog/route.js": "./src/routes/ExecutActionLog/route.js",
	"./MyConnectors/route.js": "./src/routes/MyConnectors/route.js",
	"./Roma/route.js": "./src/routes/Roma/route.js",
	"./Statistic/route.js": "./src/routes/Statistic/route.js",
	"./allNewspage/route.js": "./src/routes/allNewspage/route.js",
	"./app-robot/route.js": "./src/routes/app-robot/route.js",
	"./appdetail-v2/route.js": "./src/routes/appdetail-v2/route.js",
	"./appdetail/route.js": "./src/routes/appdetail/route.js",
	"./appinfo/route.js": "./src/routes/appinfo/route.js",
	"./certifyPage/route.js": "./src/routes/certifyPage/route.js",
	"./connectionFlow/route.js": "./src/routes/connectionFlow/route.js",
	"./connectlowExecution/route.js": "./src/routes/connectlowExecution/route.js",
	"./connectorFlowMonitoring/route.js": "./src/routes/connectorFlowMonitoring/route.js",
	"./create-robot/route.js": "./src/routes/create-robot/route.js",
	"./createFeedback/route.js": "./src/routes/createFeedback/route.js",
	"./createRoma/route.js": "./src/routes/createRoma/route.js",
	"./createTriggeringEvent/route.js": "./src/routes/createTriggeringEvent/route.js",
	"./createwecode/route.js": "./src/routes/createwecode/route.js",
	"./demoExecutionAct/route.js": "./src/routes/demoExecutionAct/route.js",
	"./doc/route.js": "./src/routes/doc/route.js",
	"./editTriiggrtEvent/route.js": "./src/routes/editTriiggrtEvent/route.js",
	"./form-resources/route.js": "./src/routes/form-resources/route.js",
	"./guidePage/route.js": "./src/routes/guidePage/route.js",
	"./home/route.js": "./src/routes/home/route.js",
	"./licenseInfo/route.js": "./src/routes/licenseInfo/route.js",
	"./market/route.js": "./src/routes/market/route.js",
	"./new-approval-right/route.js": "./src/routes/new-approval-right/route.js",
	"./new-approval/route.js": "./src/routes/new-approval/route.js",
	"./new-apps/route.js": "./src/routes/new-apps/route.js",
	"./new-article/route.js": "./src/routes/new-article/route.js",
	"./new-enterprise-detail/route.js": "./src/routes/new-enterprise-detail/route.js",
	"./new-enterprise/route.js": "./src/routes/new-enterprise/route.js",
	"./new-form/route.js": "./src/routes/new-form/route.js",
	"./new-hardware-detail/route.js": "./src/routes/new-hardware-detail/route.js",
	"./new-hardware/route.js": "./src/routes/new-hardware/route.js",
	"./new-indexsearch/route.js": "./src/routes/new-indexsearch/route.js",
	"./new-market/route.js": "./src/routes/new-market/route.js",
	"./new-priviledge/route.js": "./src/routes/new-priviledge/route.js",
	"./new-router/chinaInternational/route.js": "./src/routes/new-router/chinaInternational/route.js",
	"./new-router/doc/route.js": "./src/routes/new-router/doc/route.js",
	"./new-router/home/route.js": "./src/routes/new-router/home/route.js",
	"./new-router/migrate-to-welink/route.js": "./src/routes/new-router/migrate-to-welink/route.js",
	"./new-router/numberBlueSky/route.js": "./src/routes/new-router/numberBlueSky/route.js",
	"./new-router/shanghaiInstituteofTechnology/route.js": "./src/routes/new-router/shanghaiInstituteofTechnology/route.js",
	"./new-solution-detail/route.js": "./src/routes/new-solution-detail/route.js",
	"./new-solution/route.js": "./src/routes/new-solution/route.js",
	"./new-topic/route.js": "./src/routes/new-topic/route.js",
	"./popularize/module/route.js": "./src/routes/popularize/module/route.js",
	"./popularize/route.js": "./src/routes/popularize/route.js",
	"./robot-info/route.js": "./src/routes/robot-info/route.js",
	"./routes-redBlue/add-ability/route.js": "./src/routes/routes-redBlue/add-ability/route.js",
	"./routes-redBlue/api-manage/route.js": "./src/routes/routes-redBlue/api-manage/route.js",
	"./routes-redBlue/app-capabilities-manage/app-capabilities-addPush/route.js": "./src/routes/routes-redBlue/app-capabilities-manage/app-capabilities-addPush/route.js",
	"./routes-redBlue/app-capabilities-manage/app-capabilities-edit/route.js": "./src/routes/routes-redBlue/app-capabilities-manage/app-capabilities-edit/route.js",
	"./routes-redBlue/app-capabilities-manage/app-capabilities-list/route.js": "./src/routes/routes-redBlue/app-capabilities-manage/app-capabilities-list/route.js",
	"./routes-redBlue/app-capabilities-manage/app-capabilities-wecode/route.js": "./src/routes/routes-redBlue/app-capabilities-manage/app-capabilities-wecode/route.js",
	"./routes-redBlue/approve-manage/route.js": "./src/routes/routes-redBlue/approve-manage/route.js",
	"./routes-redBlue/capability-manage/route.js": "./src/routes/routes-redBlue/capability-manage/route.js",
	"./routes-redBlue/complaint-detail/route.js": "./src/routes/routes-redBlue/complaint-detail/route.js",
	"./routes-redBlue/complaint-manage/route.js": "./src/routes/routes-redBlue/complaint-manage/route.js",
	"./routes-redBlue/credentials-info/route.js": "./src/routes/routes-redBlue/credentials-info/route.js",
	"./routes-redBlue/entry-group-notification/route.js": "./src/routes/routes-redBlue/entry-group-notification/route.js",
	"./routes-redBlue/event-callback/route.js": "./src/routes/routes-redBlue/event-callback/route.js",
	"./routes-redBlue/home/route.js": "./src/routes/routes-redBlue/home/route.js",
	"./routes-redBlue/member-manage/route.js": "./src/routes/routes-redBlue/member-manage/route.js",
	"./routes-redBlue/no-permission/route.js": "./src/routes/routes-redBlue/no-permission/route.js",
	"./routes-redBlue/operation-management/route.js": "./src/routes/routes-redBlue/operation-management/route.js",
	"./routes-redBlue/project-configuration/route.js": "./src/routes/routes-redBlue/project-configuration/route.js",
	"./routes-redBlue/version-detail/route.js": "./src/routes/routes-redBlue/version-detail/route.js",
	"./routes-redBlue/version/route.js": "./src/routes/routes-redBlue/version/route.js",
	"./search/route.js": "./src/routes/search/route.js",
	"./singleQuestion/route.js": "./src/routes/singleQuestion/route.js",
	"./solution-edit/route.js": "./src/routes/solution-edit/route.js",
	"./solution/route.js": "./src/routes/solution/route.js",
	"./subscription-statistics/route.js": "./src/routes/subscription-statistics/route.js",
	"./weForm/route.js": "./src/routes/weForm/route.js",
	"./weForm/submit/route.js": "./src/routes/weForm/submit/route.js",
	"./weVote/route.js": "./src/routes/weVote/route.js",
	"./wecode-v2/route.js": "./src/routes/wecode-v2/route.js",
	"./wecode/route.js": "./src/routes/wecode/route.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/routes sync recursive route.js$";